import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'


Vue.use(Vuex)


if(window.location.hostname === 'localhost'){
  axios.defaults.baseURL = 'http://' + window.location.hostname + ':8000/api'
}else{
  axios.defaults.baseURL = 'https://zeus.azevedoseg.com/public/api'
}


export const store = new Vuex.Store({
  state: {
    token: localStorage.getItem('access_token') || null,
    products: [],
    clients: [],
    os:[],
    client: [],
    services: [],
    receipts: [],
    dashboard: [],
    user: [],
    files: []
  },


  getters: {
    isLoggedIn(state) {
      return state.token
    },
    products(state) {
      return state.products
    },
    clients(state) {
      return state.clients
    },
    os(state) {
      return state.os
    },
    client(state) {
      return state.client
    },
    product(state) {
      return state.product
    },
    services(state) {
      return state.services
    },
    receipts(state) {
      return state.receipts
    },
    dashboard(state) {
      return state.dashboard
    },
    user(state) {
      return state.user
    },
    cep(state) {
      return state.cep
    },
    files(state) {
      return state.files
    }

  },
  mutations: {
    getCep(state, cep) {
      state.cep = cep
    },
    retrieveToken(state, token) {
      state.token = token
    },
    destroyToken(state) {
      state.token = null
    },
    getProducts(state, products) {
      state.products = products
    },
    getClients(state, clients) {
      state.clients = clients
    },
    getOs(state, os) {
      state.os = os
    },
    getClientById(state, client) {
      state.client = client
    },
    getProductById(state, product) {
      state.product = product
    },
    getServices(state, services) {
      state.services = services
    },
    getReceipts(state, receipts) {
      state.receipts = receipts
    },
    getDashboard(state, dashboard) {
      state.dashboard = dashboard
    },
    getUser(state, user) {
      state.user = user
    },
    getFiles(state, files) {
      state.files = files
    }
  },
  actions: {
    register(context, data) {
      return new Promise((resolve, reject) => {
        axios.post('/Auth/register', {
          first_name: data.first_name,
          last_name: data.last_name,
          email: data.email,
          password: data.password,
        })
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    destroyToken(context) {
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.state.token

      if (context.getters.isLoggedIn) {
        return new Promise((resolve, reject) => {
          axios.post('/Auth/logout')
            .then(response => {
              localStorage.removeItem('access_token')
              context.commit('destroyToken')
              resolve(response)

              // console.log(response);
              // context.commit('addTodo', response.data)
            })
            .catch(error => {
              localStorage.removeItem('access_token')
              context.commit('destroyToken')
              reject(error)
            })
        })
      }
    },

    getUser(context) {
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.state.token
      axios.get('/user')
        .then(response => {
          context.commit('getUser', response.data)
        }).catch(error => {
          console.log(error)
        })
    },
    retrieveToken(context, credentials) {
      return new Promise((resolve, reject) => {
        axios.post('/Auth/login', {
          email: credentials.email,
          password: credentials.password,
        })

          .then(response => {
            const token = response.data.access_token
            localStorage.setItem('access_token', token)
            context.commit('retrieveToken', token)
            resolve(response)
          })
          .catch(error => {
            console.log(error)
            reject(error)
          })
      })
    },


    // Produtos 
    getProducts(context, page) {
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.state.token

      if (page) {
        axios.get('/products?page=' + page.page)
          .then(response => {
            context.commit('getProducts', response.data)
          })
          .catch(error => {
            console.log(error)
          })
      } else {
        axios.get('/products')
          .then(response => {
            context.commit('getProducts', response.data)
          })
          .catch(error => {
            console.log(error)
          })
      }
    },

    deletProduct(context, data) {
      return new Promise((resolve, reject) => {
        axios.post('/deletProduct', data,
         )
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    deleteService(context, data) {
      return new Promise((resolve, reject) => {
        axios.post('/deleteService', data,
         )
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    deleteOs(context, data) {
      return new Promise((resolve, reject) => {
        axios.post('/deleteOs', data,
         )
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    getProductById(context, data) {
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.state.token
      return new Promise((resolve) => {
      axios.get('/product?id=' + data)
        .then(response => {
          context.commit('getProductById', response.data)
          resolve(response.data)
        })
        .catch(error => {
          console.log(error)
        })
})
    },

    updateService(context, data) {
      return new Promise((resolve, reject) => {
        axios.post('/editService', data)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    editProduct(context, data) {
      return new Promise((resolve, reject) => {
        axios.post('/editProduct', data)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    getAuth(context) {
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.state.token
      axios.get('/isAuth')
        .then(response => {
          context.commit('getAuth', response.data)
        })
        .catch(error => {
          console.log(error)
        })
    },

    getClients(context, page) {
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.state.token

      if (page) {
        axios.get('/clients?page=' + page.page)
          .then(response => {
            context.commit('getClients', response.data)
          })
          .catch(error => {
            console.log(error)
          })
      } else {
        axios.get('/clients')
          .then(response => {
            context.commit('getClients', response.data)
          })
          .catch(error => {
            console.log(error)
          })
      }
    },

    getAllClients(context, data) {
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.state.token
      return new Promise((resolve) => {
      axios.get('/clients?all=true&data=' + data)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          console.log(error)
        })
      })
    },
    getAllUsers(context, data) {
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.state.token
      return new Promise((resolve) => {
      axios.get('/users?all=true&data=' + data)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          console.log(error)
        })
      })
    },
    getStatusOs(context) {
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.state.token
      return new Promise((resolve) => {
      axios.get('/getStatusOs')
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          console.log(error)
        })
      })
    },


    addOs(context, data) {
      return new Promise((resolve, reject) => {
        axios.post('/addOs', data)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    getOs(context, page) {
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.state.token

      if (page) {
        axios.get('/os?page=' + page.page)
          .then(response => {
            context.commit('getOs', response.data)
          })
          .catch(error => {
            console.log(error)
          })
      } else {
        axios.get('/os')
          .then(response => {
            context.commit('getOs', response.data)
          })
          .catch(error => {
            console.log(error)
          })
      }
    },

    getOsById(context, data) {
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.state.token
      return new Promise((resolve, reject) => {
      axios.get('/os?id=' + data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
      })
    },

    getClientById(context, data) {
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.state.token

      axios.get('/client?id=' + data)
        .then(response => {
          context.commit('getClientById', response.data)
        })
        .catch(error => {
          console.log(error)
        })
    },

    editClient(context, data) {
      return new Promise((resolve, reject) => {
        axios.post('/editClient', data)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },


    editOs(context, data) {
      return new Promise((resolve, reject) => {
        axios.post('/editOs', data)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },


    addProduct(context, data) {
      return new Promise((resolve, reject) => {
        axios.post('/addProduct', data, {
                 headers: {
                     'Content-Type': 'multipart/form-data'
                 }
            })
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },


        addService(context, data) {
      return new Promise((resolve, reject) => {
        axios.post('/addService', data)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },


    addClient(context, data) {
      return new Promise((resolve, reject) => {
        axios.post('/addClient', {
          name_client: data.name_client,
          document_client: data.document_client,
          telephone_client: data.telephone_client,
          cellphone_client: data.cellphone_client,
          email_client: data.email_client,
          street_client: data.street_client,
          cep_client: data.cep_client,
          city_client: data.city_client,
          district_client: data.district_client,
          juridic_person: data.juridic_person,
          number_client: data.number_client,
          state_client: data.state_client
        })
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    uploadFile(context, data) {
      return new Promise((resolve, reject) => {
        axios.post('/store-file', data,
            {
                 headers: {
                     'Content-Type': 'multipart/form-data'
                 }
            })
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    getFiles(context){ 
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.state.token 
      axios.get('/store-file').then(response => {
       context.commit('getFiles', response.data)
    
    })
    },

    deletClient(context, data) {
      return new Promise((resolve, reject) => {
        axios.post('/deletClient', {
          id: data.id,
        })
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    getServices(context, page) {
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.state.token

      if (page) {
        axios.get('/services?page=' + page.page)
          .then(response => {
            context.commit('getServices', response.data)
          })
          .catch(error => {
            console.log(error)
          })
      } else {
        axios.get('/services')
          .then(response => {
            context.commit('getServices', response.data)
          })
          .catch(error => {
            console.log(error)
          })
      }
    },
    getReceipts(context, page) {
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.state.token

      if (page) {
        axios.get('/receipts?page=' + page.page)
          .then(response => {
            context.commit('getReceipts', response.data)
          })
          .catch(error => {
            console.log(error)
          })
      } else {
        axios.get('/receipts')
          .then(response => {
            context.commit('getReceipts', response.data)
          })
          .catch(error => {
            console.log(error)
          })
      }
    },
    getDashboard(context) {
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.state.token

      axios.get('/dashboard')
        .then(response => {
          context.commit('getDashboard', response.data)
        })
        .catch(error => {
          console.log(error)
        })

    }


  }
})
